<a class="signal-row d-flex align-items-center" [attr.data-severity]="entry().severity"
  [routerLink]="entry().routerLink">
  <span class="signal-rail" aria-hidden="true"></span>

  <span class="signal-icon d-flex align-items-center justify-content-center flex-shrink-0">
    <mat-icon>{{ entry().icon }}</mat-icon>
  </span>

  <span class="signal-body d-flex flex-column min-w-0">
    <span class="signal-title text-truncate">{{ entry().titleKey | translate }}</span>
    <span class="signal-description">{{ entry().descriptionKey | translate: entry().descriptionParams }}</span>
  </span>

  @if (entry().count !== null) {
  <span class="signal-count flex-shrink-0">{{ entry().count }}</span>
  }

  <mat-icon class="signal-chevron flex-shrink-0">chevron_right</mat-icon>
</a>
